import { Link, router } from '@inertiajs/react'
import { Section } from '@/components/design-system/Section'
import { formatNumber, formatDate } from '@/frontend/pages/CommandCenter/Telemetry/utils'

interface Organization {
  id: string
  name: string
  slug: string
  sessionsCount: number
  totalTokens: number
  lastActivityAt: string | null
}

interface Props {
  organizations: Organization[]
}

export default function TopOrganizationsSection({ organizations }: Props) {
  return (
    <Section title="Top Organizações" action={{ content: 'Ver todas', onAction: () => router.visit('/cc/telemetry') }}>
      {organizations.length === 0 ? (
        <p className="text-sm text-muted-foreground py-4 text-center">Nenhuma organização com atividade.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-border">
                <th className="text-left py-2 text-xs font-medium text-muted-foreground uppercase tracking-wider">Organização</th>
                <th className="text-right py-2 text-xs font-medium text-muted-foreground uppercase tracking-wider">Sessões</th>
                <th className="text-right py-2 text-xs font-medium text-muted-foreground uppercase tracking-wider">Tokens</th>
                <th className="text-right py-2 text-xs font-medium text-muted-foreground uppercase tracking-wider">Última Atividade</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {organizations.map((org) => (
                <tr key={org.id} className="hover:bg-accent transition-colors">
                  <td className="py-2 pr-4">
                    <Link href={`/cc/telemetry/organizations/${org.slug}`} className="text-sm font-medium text-foreground hover:text-blue-600">
                      {org.name}
                    </Link>
                  </td>
                  <td className="py-2 text-right text-sm text-foreground">{formatNumber(org.sessionsCount)}</td>
                  <td className="py-2 text-right text-sm text-foreground">{formatNumber(org.totalTokens)}</td>
                  <td className="py-2 text-right text-sm text-muted-foreground">{org.lastActivityAt ? formatDate(org.lastActivityAt) : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Section>
  )
}
